var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLastLoginDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "right-to-bracket-solid",
    d: "M10.214,35.464,15.97,41.22a1.811,1.811,0,0,1,0,2.559l-5.756,5.756A1.591,1.591,0,0,1,7.5,48.411V45.5h-6A1.5,1.5,0,0,1,0,44V41a1.5,1.5,0,0,1,1.5-1.5h6V36.589a1.591,1.591,0,0,1,2.714-1.125ZM16.5,50h3A1.5,1.5,0,0,0,21,48.5v-12A1.5,1.5,0,0,0,19.5,35h-3a1.5,1.5,0,0,1,0-3h3A4.5,4.5,0,0,1,24,36.5v12A4.5,4.5,0,0,1,19.5,53h-3a1.5,1.5,0,0,1,0-3Z",
    transform: "translate(0 -32)",
    fill: "#c9c9c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastLoginDateIcon);
export default __webpack_public_path__ + "static/media/last-login-date-icon.31beff88e0dae220ed5a5f34d29e2f9b.svg";
export { ForwardRef as ReactComponent };